<template>
  <div>
    <div v-if="users">
      <div class="grid-x grid-margin-x">
        <div class="cell medium-6 text-gray-80 italic">
          {{ users.length }}
          <span v-html="textUsersFound"></span>
        </div>
        <div class="cell medium-6 flex md:justify-end">
          <div class="form-group">
            <div class="form-group--inline">
              <label for="selectSortby" class="form-label" v-html="textSortBy"></label>
              <div class="select select--clear">
                <select id="selectSortby" v-model="sortKey" class="form-control">
                  <option
                    v-for="(column, colIndex) in tableHeaders"
                    :key="colIndex"
                    :value="column.key"
                    qaid="`sort-list.option-${column.key}`"
                    v-html="column.label"
                  ></option>
                </select>
                <div class="focus-indicator"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="section pt-0">
        <users-grid :grid-data="sortedUsers" :columns="tableHeaders" :id-key="uid" />
      </section>
    </div>
    <div v-else>
      <div v-html="textNoUserMessage"></div>
    </div>
  </div>
</template>

<script>
import orderBy from 'lodash/orderBy';

export default {
  provide() {
    return {
      container: this,
    };
  },

  props: {
    userData: {
      type: Object,
      default: () => {},
    },
    tableHeaders: {
      type: Array,
      default: () => [],
    },
    textNoUserMessage: {
      type: String,
      default: '',
    },
    textUsersFound: {
      type: String,
      default: '',
    },
    textSortBy: {
      type: String,
      default: '',
    },
    uid: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      sortKey: 'name',
    };
  },

  computed: {
    users() {
      if (!this.userData.users) return [];
      return this.userData.users;
    },

    sortDirection() {
      return this.sortKey === 'userStatus' ? 'desc' : 'asc';
    },

    sortedUsers() {
      return orderBy(
        this.users,
        [(user) => (user[this.sortKey] ? user[this.sortKey].toLowerCase() : null)],
        [this.sortDirection]
      );
    },
  },
};
</script>
